const OrderDetailPayment = class {
  constructor({ method, amount, paymentAmount, paymentKey }) {
    this.method = method
    this.amount = amount
    this.paymentAmount = paymentAmount
    this.paymentKey = paymentKey
  }

  isBaeminPayPayment() {
    return this.method === '배민페이 신용카드'
  }
}

export default null

export const ofOrderDetailPayment = (params = {}) => new OrderDetailPayment(params)
